var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsBlockchain02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 37C19.927 37 20.3242 36.8022 21.1205 36.405L27.508 33.2253C30.3378 31.82 31.75 31.1148 31.75 30V16M19.5 37C19.073 37 18.6758 36.8022 17.8795 36.405L11.492 33.2253C8.66225 31.82 7.25 31.1148 7.25 30V16M19.5 37V23M31.75 16C31.75 14.8852 30.336 14.1817 27.5097 12.7747L21.1205 9.59325C20.3225 9.19775 19.927 9 19.5 9M31.75 16C31.75 17.1148 30.336 17.8183 27.5097 19.2253L21.1205 22.4068C20.3242 22.8023 19.927 23 19.5 23M7.25 16C7.25 14.8852 8.66225 14.18 11.492 12.7747L17.8795 9.595C18.6758 9.19775 19.073 9 19.5 9M7.25 16C7.25 17.1148 8.664 17.8183 11.4902 19.2253L17.8795 22.4068C18.6758 22.8023 19.073 23 19.5 23M19.5 9V2M37 35.25L31.75 30.875M2 35.25L7.25 30.875",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsBlockchain02);
export default __webpack_public_path__ + "static/media/hugeicons_blockchain-02.bc58089b8c5b498f464f36582b8a7dd9.svg";
export { ForwardRef as ReactComponent };